/* eslint-disable security/detect-object-injection */
/* eslint-disable no-debugger */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable import/no-unresolved */
import { Dispatch, Fragment, SetStateAction, memo, useEffect } from "react";
import Resources from "src/config/Resources";
import { FormikProps } from "formik";
import { FilterOptions } from "src/helpers/Dashboard/interface";
import { OPTIONS } from "src/helpers/Dashboard/resources";
import CustomSelect from "src/shared/CustomSelect";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { Button } from "@mui/material";
import { Transition } from "@headlessui/react";
import CustomSlider from "../../../../shared/CustomSlider";
import Status from "./Status";

interface Props {
  onCloseClick: Dispatch<SetStateAction<any>>;
  isOpen: boolean;
  formik: FormikProps<FilterOptions>;
}
function QueryFilterModal({ onCloseClick, formik, isOpen }: Props) {
  const filterOptions = useAppSelector((state) => state.dashboard.filterOptions);
  const { product: productData = {} } = useAppSelector((state) => state.masterdata_reducer);

  useEffect(() => {
    if (formik.values?.policyTerm === "None") formik.setFieldValue("policyTerm", "");
  }, [formik.values?.policyTerm]);
  return (
    <Transition
      as={Fragment}
      show={isOpen}
      afterEnter={() => {
        formik.setValues(filterOptions);
      }}
      enter="transform transition duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100 translate-y-28 md:translate-y-14 scale-100"
      leave="transform duration-150 transition ease-in-out"
      leaveFrom="opacity-100 scale-100 "
      leaveTo="opacity-0 scale-95 "
    >
      <div className="min-h-[329px] min-w-[338px] absolute right-3 md:right-14 z-30 bg-white shadow-lg rounded-lg font-montserrat">
        <div className="flex flex-col justify-between px-6 py-3 md:flex-row md:space-y-0">
          <div className="items-center hidden text-lg font-bold md:flex">Filters</div>
          <div className="flex items-center space-x-6 md:justify-center">
            <Button
              // disabled={actionButtonDisabled()}
              variant="contained"
              onClick={() => {
                formik.handleSubmit();
              }}
              classes={{ root: "!h-8" }}
              className="rounded-lg"
            >
              Apply
            </Button>
            <Button
              // disabled={actionButtonDisabled()}
              variant="outlined"
              onClick={() => formik.resetForm()}
              classes={{ root: "!h-8 !border-gray-700 !text-black" }}
              className="rounded-lg"
            >
              Clear all
            </Button>
            <div className="cursor-pointer" onClick={onCloseClick}>
              <img src={Resources.images.Dashboard.closeIcon} alt="close" />
            </div>
          </div>
        </div>
        <hr className="border" />
        <div className="flex flex-col justify-between px-6 py-6 space-y-5 md:flex-row md:space-y-0">
          <div className="pr-4">
            <div>
              <div className="text-sm font-semibold">Product</div>
              <CustomSelect
                className="w-32 mt-3"
                label="Select"
                name="product"
                onChange={(e: any) => {
                  const productId = Object.keys(productData).find(
                    (pId: string) => productData[pId] === e.target.value
                  );
                  formik.setFieldValue("product", productId);
                }}
                options={Object.values(productData)}
                setFieldTouched={formik.setFieldTouched}
                value={productData[formik.values.product] || ""}
              />
            </div>
            <div className="mt-4">
              <CustomSlider
                heading="Sum Assured"
                valueLabelFormat={(labelValue: number) => {
                  if (labelValue >= 1000000 && labelValue < 10000000) {
                    const finalValue = labelValue / 100000;
                    return `${
                      Number.isInteger(finalValue) ? finalValue : finalValue.toFixed(2)
                    } Lacs`;
                  }
                  const finalValue = labelValue / 10000000;
                  return `${Number.isInteger(finalValue) ? finalValue : finalValue.toFixed(2)} Cr`;
                }}
                name="sumAssured"
                range={{
                  min: 1000000,
                  max: 100000000
                }}
                steps={1000}
                formik={{
                  value: formik.values.sumAssured,
                  setFieldValue: formik.setFieldValue,
                  handleChange: formik.handleChange
                }}
              />
            </div>
            <div className="mt-5">
              <CustomSlider
                heading="Premium"
                valueLabelFormat={(labelValue: number) =>
                  `${Number(labelValue).toLocaleString("en-IN")}`
                }
                name="premium"
                range={{ min: 1000, max: 5000000 }}
                steps={1000}
                formik={{
                  value: formik.values.premium,
                  setFieldValue: formik.setFieldValue,
                  handleChange: formik.handleChange
                }}
              />
            </div>
            <div className="mt-5">
              <CustomSlider
                heading="Loan Amount"
                valueLabelFormat={(labelValue: number) =>
                  `${Number(labelValue).toLocaleString("en-IN")}`
                }
                name="loanAmount"
                range={{ min: 1000, max: 300000000 }}
                steps={1000}
                formik={{
                  value: formik.values.loanAmount,
                  setFieldValue: formik.setFieldValue,
                  handleChange: formik.handleChange
                }}
              />
            </div>
          </div>
          <div className="flex flex-col md:ml-2">
            <div className="flex justify-between md:space-x-2">
              <Status
                className="w-32"
                name="proposalStatus"
                formik={{
                  value: formik.values.proposalStatus,
                  setFieldValue: formik.setFieldValue
                }}
                heading="Proposal Status"
                options={OPTIONS.filterProposalStatus}
              />
              <Status
                className="w-32"
                name="loanStatus"
                formik={{ value: formik.values.loanStatus, setFieldValue: formik.setFieldValue }}
                heading="Loan Status"
                options={OPTIONS.filterLoanStatus}
              />
            </div>
            <div className="flex justify-between mt-10 md:space-x-2">
              <Status
                className="w-32"
                name="paymentStatus"
                formik={{ value: formik.values.paymentStatus, setFieldValue: formik.setFieldValue }}
                heading="Payment Status"
                options={OPTIONS.filterPaymentStatus}
              />
              <Status
                className="w-32"
                name="sparkDecision"
                formik={{
                  value: formik.values.sparkDecision,
                  setFieldValue: formik.setFieldValue
                }}
                heading="Spark Decision"
                options={OPTIONS.filterSparkDecision.map(
                  (option: { description: any }) => option.description
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
}

export default memo(QueryFilterModal);
